import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

import { getPanelPaddingVars } from './panel-padding';

export default function Save( { attributes } ) {
	const { imageUrl, imageAlt } = attributes;

	const paddingVars = getPanelPaddingVars( attributes );

	const blockProps = useBlockProps.save( {
		className: 'brandy-accordion-panel',
		style: Object.keys( paddingVars ).length ? paddingVars : undefined,
	} );

	return (
		<div { ...blockProps }>
			{ imageUrl && (
				<img
					src={ imageUrl }
					alt={ imageAlt }
					className="brandy-accordion-panel__image"
				/>
			) }
			<div className="brandy-accordion-panel__overlay">
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
